import { SocialIcon } from 'react-social-icons';

const Footer = () => {
  return (
    <footer className="footer-bg-color text-white px-6 py-8">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between">
        <div>
          <h3 className="font-bold text-lg mb-2">Tajni prostor webshop</h3>
          <p>11000 Beograd, Srbija</p>
          <p>Email: tajniprostor@outlook.com</p>
          <p>
            <a
              href="https://www.instagram.com/tajni_prostor/?igsh=dnpidDU4M3owNmJt#"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:opacity-80 transition"
            >
              <SocialIcon
                url="https://www.instagram.com/tajni_prostor/?igsh=dnpidDU4M3owNmJt#"
                bgColor="transparent"
                fgColor="#ffffff"      // icon white
                style={{ width: 30, height: 30 }}
              />
              <span className="text-white text-lg">@tajni_prostor</span>
            </a>
          </p>
        </div>
        <div>
          <h3 className="font-bold text-lg mb-2">Stranice</h3>
          <ul>
            <li><a href="/shop" className="hover:underline">Prodavnica</a></li>
            <li><a href="/blog" className="hover:underline">Blog</a></li>
            <li><a href="/contact" className="hover:underline">Kontakt</a></li>
          </ul>
        </div>
      </div>
      <div className="text-center mt-4 text-sm">&copy; {new Date().getFullYear()} Webshop. All rights reserved.</div>
    </footer>
  );
};

export default Footer;
